import { inject, injectable } from 'inversify'

import { RoutingService } from '#AltServices'

@injectable()
export class ReviewsRoutingService {
  constructor(@inject(RoutingService) readonly router: RoutingService) {}

  /** «Мои отзывы» в личном кабинете. */
  get index() {
    return this.router.createRouteData({ name: 'ReviewsIndex' })
  }
}
